/**
 * T223.D — Customer refund API client.
 *
 * Three endpoints (gated server-side to request.user == requested_by):
 *
 *   GET    /api/payments/refunds/         — own refund list
 *   POST   /api/payments/refunds/         — create new request
 *   GET    /api/payments/refunds/<uuid>/  — single detail + timeline
 */
import api from "./axios";

export const listRefunds = () =>
  api.get("/api/payments/refunds/");

export const getRefund = (id) =>
  api.get(`/api/payments/refunds/${id}/`);

/**
 * Create a refund request. amountInr is rupees; backend converts to paise.
 * reasonCode is one of:
 *   DUPLICATE_CHARGE / SERVICE_NOT_DELIVERED / DOWNGRADE_PRORATA /
 *   GOODWILL / OTHER.
 * (DISPUTE_AUTO is system-only and not selectable.)
 */
export const createRefund = ({
  subscriptionId,
  amountInr,
  reasonCode,
  customerFacingReason,
}) =>
  api.post("/api/payments/refunds/", {
    subscription_id: subscriptionId,
    amount_inr: amountInr,
    reason_code: reasonCode,
    customer_facing_reason: customerFacingReason,
  });
